import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	multipleAppsConflicted: {
		id: 'ui-modifications-view-gic.use-ui-modifications-notifications.multiple-apps-conflicted',
		defaultMessage:
			'Multiple UI modification apps are trying to change the same field property. If you see unexpected changes to a field, report them to your Jira admin.',
		description:
			'A information that gets displayed when UI modifications misconfiguration was detected',
	},
	uimMultipleApps: {
		id: 'ui-modifications-view-gic.use-ui-modifications-notifications.uim-multiple-apps',
		defaultMessage:
			'We have added support for multiple UI modification apps. Your admin has installed more than one app that can make changes to this screen.',
		description:
			'A information that gets displayed when UI modifications multiple apps in the context were detected',
	},
});
